document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".team-block__details").forEach((detail) => {
        detail.addEventListener("toggle", function () {
            let parentBlock = this.closest(".team_block");
            if (this.open) {
                parentBlock.classList.add("active");
            } else {
                parentBlock.classList.remove("active");
            }
        });
    });
});

{
    document.addEventListener('DOMContentLoaded', function () {
        const tabsContainer = document.querySelector('.vertical-tabs__buttons');
        const contents = document.querySelectorAll('.vertical-tabs__content');

        tabsContainer.addEventListener('click', function (event) {
            const button = event.target.closest('.vertical-tabs__button');
            if (!button) return;

            const targetId = button.getAttribute('data-tab');

            // Remove active classes
            tabsContainer.querySelectorAll('.vertical-tabs__button').forEach(btn => btn.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));

            // Add active classes
            button.classList.add('active');
            document.getElementById(targetId).classList.add('active');
        });

        // Activate the first tab by default
        const firstButton = tabsContainer.querySelector('.vertical-tabs__button');
        const firstContent = contents[0];
        if (firstButton && firstContent) {
            firstButton.classList.add('active');
            firstContent.classList.add('active');
        }
    });
}